<script>
  import { createPopper } from "@popperjs/core";
  import { auth, user } from "../../stores/auth.js";
  import { link } from "svelte-routing";

  let dropdownPopoverShow = false;
  let btnDropdownRef;
  let popoverDropdownRef;
  let imageError = false;

  function toggleDropdown(event) {
    event.preventDefault();
    if (dropdownPopoverShow) {
      dropdownPopoverShow = false;
    } else {
      dropdownPopoverShow = true;
      createPopper(btnDropdownRef, popoverDropdownRef, {
        placement: "bottom-end",
        modifiers: [{ name: "offset", options: { offset: [0, 8] } }],
      });
    }
  }

  function handleImageError() {
    imageError = true;
  }

  // Reset image error when user changes
  $: if ($user) {
    imageError = false;
  }
</script>

<div>
  <button
    type="button"
    class="flex items-center gap-3 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-moira focus-visible:ring-offset-2"
    bind:this={btnDropdownRef}
    on:click={toggleDropdown}
    aria-label="Account menu"
  >
    <span class="w-9 h-9 inline-flex items-center justify-center rounded-full bg-surface-variant overflow-hidden border border-line">
      {#if $user?.picture && !imageError}
        <img
          alt="User avatar"
          class="w-full h-full object-cover"
          src={$user.picture}
          on:error={handleImageError}
        />
      {:else}
        <i class="fas fa-user text-ink-tertiary"></i>
      {/if}
    </span>
  </button>

  <div
    bind:this={popoverDropdownRef}
    class="card shadow-sm z-50 py-1.5 min-w-[14rem] {dropdownPopoverShow ? 'block' : 'hidden'}"
  >
    {#if $user}
      <div class="px-4 py-2.5 border-b border-line mb-1">
        <p class="text-sm font-semibold text-ink truncate">{$user.name || "Account"}</p>
        {#if $user.email}
          <p class="text-xs text-ink-tertiary truncate mt-0.5">{$user.email}</p>
        {/if}
      </div>
    {/if}
    <a
      use:link
      href="/admin/settings"
      class="flex items-center gap-2.5 text-sm text-ink px-4 py-2 hover:bg-canvas transition-colors"
      on:click={() => (dropdownPopoverShow = false)}
    >
      <i class="fas fa-user-circle text-ink-tertiary w-4 text-center"></i>
      Settings
    </a>
    <a
      use:link
      href="/admin/documents"
      class="flex items-center gap-2.5 text-sm text-ink px-4 py-2 hover:bg-canvas transition-colors"
      on:click={() => (dropdownPopoverShow = false)}
    >
      <i class="fas fa-file-alt text-ink-tertiary w-4 text-center"></i>
      Documents
    </a>
    <div class="border-t border-line my-1"></div>
    <button
      on:click={() => auth.logout()}
      class="flex items-center gap-2.5 w-full text-left text-sm text-ink px-4 py-2 hover:bg-canvas transition-colors"
    >
      <i class="fas fa-sign-out-alt text-ink-tertiary w-4 text-center"></i>
      Sign out
    </button>
  </div>
</div>
